export default __webpack_public_path__ + "img/instra1.36ad19aa.jpg";